import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateCertificadoEmpresaItByID = () => {
  const [loadingUpdateCertificadoEmpresaById, setLoadingCreateCertificadoEmpresa] = useState(false);
  const [successUpdateCertificadoEmpresaById, setSuccessCreateCertificadoEmpresa] = useState(false);
  const [errorUpdateCertificadoEmpresaById, setErrorCreateCertificadoEmpresa] = useState(null);
  const [dataUpdateCertificadoEmpresaById, setDataCertificadoEmpresa] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateCertificadoEmpresaById = async (userId:string ,prestacionId: string, formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateCertificadoEmpresa(true);
    setSuccessCreateCertificadoEmpresa(false);
    setErrorCreateCertificadoEmpresa(null);

    apiRecord.updateCertificadoEmpresaItByID(userId, prestacionId, formId, data).then((res: any) => {
      setLoadingCreateCertificadoEmpresa(false);
      setSuccessCreateCertificadoEmpresa(true);
      setDataCertificadoEmpresa(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateCertificadoEmpresa(false);
      setErrorCreateCertificadoEmpresa(err.response.data)
    })
  }

  return {
    updateCertificadoEmpresaById,
    loadingUpdateCertificadoEmpresaById,
    successUpdateCertificadoEmpresaById,
    errorUpdateCertificadoEmpresaById,
    dataUpdateCertificadoEmpresaById
  }

}

export default useUpdateCertificadoEmpresaItByID;
